<div class="row" style="margin-top:65px">
  <div class="col-12 col-md-9">
    <div class="row mb-2">
      <div class="col-12 col-lg-5">
        <img src="assets/welara_animation_5s.gif" class="img-fluid radius5" alt="Welara" id="obj_animation"
             title="Welara Horse"
             style="border:solid 1px var(--welarasand);" />
      </div>
      <div class="col-12 col-lg-4 ps-0">
        <div class="card" id="divPriorities" *ngIf="userRole != 2">
          <div class="card-header">
            <i class="fas fa-fw fa-exclamation-triangle me-1"></i>This Week’s Priorities
          </div>
          <div class="card-body" style="font-size: 16px !important; font-family: FuturaPTBook !important;" [innerHTML]="prioritiesText">
          </div>
        </div>
        <div class="card" id="divPriorities" *ngIf="userRole == 2">
          <div class="card-header">
            <i class="fas fa-fw fa-exclamation-triangle me-1"></i>Account Information
          </div>
          <div class="card-body" style="font-size: 16px !important; font-family: FuturaPTBook !important;" [innerHTML]="accountInfoText">
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-3 px-0">
        <button class="btn btn-sm btn-dark c_white text-center w-100 mb-2" (click)="goRoute('hourglass')" *ngIf="(userRole != 2)">
          <i class="fas fa-fw fa-hourglass me-2"></i>Hourglass
        </button>
        <button class="btn btn-sm btn-dark c_white text-center w-100 mb-2" (click)="goRoute('academy')">
          <i class="fas fa-fw fa-graduation-cap me-2"></i>Welara Academy
        </button>
        <button class="btn btn-sm btn-dark c_white text-center w-100 mb-2" (click)="goRoute('googledriveaccess')">
          <i class="fas fa-fw fa-hard-drive me-2"></i>File Storage
        </button>
        <button class="btn btn-sm btn-dark c_white text-center w-100 mb-2 d-none" (click)="goRoute('minutes')" *ngIf="userRole == 1">
          <i class="fas fa-fw fa-clock me-2"></i>MinutesMaker
        </button>
        <button class="btn btn-sm btn-dark c_white text-center w-100 mb-2" (click)="goRoute('admin/billing')" *ngIf="userRole == 1">
          <i class="fas fa-fw fa-file-invoice-dollar me-2"></i>Billing Center
        </button>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12 col-md-7 pe-0">
        <app-btc-price-tracker></app-btc-price-tracker>
      </div>
      <div class="col-12 col-md-5 pe-0">
        <div class="card mb-2" style="height:40vh" *ngIf="userRole != 2">
          <div class="card-header">
            <i class="fas fa-fw fa-hourglass me-1"></i>Hourglass Summary
          </div>
          <div class="card-body" style="font-size: 16px !important; font-family: FuturaPTBook !important;">
            COMING SOON
          </div>
        </div>
        <div class="card" style="height:20vh" *ngIf="userRole == 2">
          <div class="card-header">
            <i class="fas fa-fw fa-file-invoice-dollar me-1"></i>Your Bill
          </div>
          <div class="card-body" style="font-size: 16px !important; font-family: FuturaPTBook !important;">
            COMING SOON
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-3">
    <div class="scroll_div radius5 border" style="height:88vh !important" id="dashCalendar" *ngIf="userRole != 2">
      <app-calendar-slim [showAddButton]="false" [targetObject]="'dashCalendar'"></app-calendar-slim>
    </div>
  </div>
</div>

